var CurrentUser = require("lib/account/CurrentUser");
var AvatarCircle = require("components/utility/icons/AvatarCircle");
var Glyphicon = require("components/utility/icons/Glyphicon");
var SpeechControls = require("components/writing/questions/SpeechControls");

var CSSTransition = require("react-transition-group/CSSTransition");
var TransitionGroup = require("react-transition-group/TransitionGroup");

var StudentMetrics = require("lib/data/StudentMetrics");

require("users/students/owlfonso_chat.scss");

class OwlfonsoChat extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { isTyping: false, currentChat: props.currentChat };
	}

	getGradeLevelExpectations(){
		var gradeLevel = CurrentUser.get().prefs.academic_level
		var glMetrics = CurrentUser.get().prefs.grade_level_expectations_metrics
		return glMetrics[gradeLevel] || glMetrics['-1']
	}

	getReplacementText(toReplace) {
		switch(toReplace) {
			case STUDENT_NAME:
				return CurrentUser.get().first_name;
			case ASSIGNMENT_METRICS:
				var metrics = this.getGradeLevelExpectations()
				var metricArray = _.map(metrics, (metricData) => {
					var label = StudentMetrics.getLabel(metricData.metric)
					if (label) {
						return metricData.goal + " " + StudentMetrics.getLabel(metricData.metric);
					} else {
						return null;
					}
				});

				return _.select(metricArray).join(", ");
			case ASSIGNMENT_TIME_PERIOD:
				return CurrentUser.get().prefs.expectations_time_period;
		}
	}
	parseCurrentChatText() {
		var currentChat = this.props.currentChat;

		// pick correct option to display based on chat history
		if (currentChat.type == "options") {
			var parts = currentChat.text.split(";");
			var chosenOption = _.find(parts, (option) => {
				return _.first(option.split("::")) === _.last(this.props.history).text;
			}).split("::");

			currentChat = _.extend({}, currentChat, { text: chosenOption[1], type: "static", increment: chosenOption[2] });
		}

		if (currentChat.text.includes("{{")) {
			var updatedText = currentChat.text;
			_.map(REPLACEMENT_STRINGS, (toReplace) => {
				updatedText = updatedText.replace(toReplace, this.getReplacementText(toReplace));
			});
			currentChat = _.extend({}, currentChat, { text: updatedText });
		}

		return currentChat;
	}

	renderChatItem(chat, key = -1) {
		var avatarCircle = <AvatarCircle avatarType={ chat.speaker } user={ CurrentUser.get() }
			initialOnly={ this.props.initialOnly } />;

		if (chat.speaker == "owlfonso") {
			var readChatControls = (
				<SpeechControls getTextToRead={ () => chat.text } readTextOnly={ true } />
			);
		}
		var chatBox = (
			<div className="chatBox">
				{ chat.text }
			</div>
		);

		return (
			<CSSTransition classNames="slide" key={ "chat-" + key }
				timeout={{ enter: 10, exit: 1 }}
				transitionEnterTimeout={ 10 } transitionLeaveTimeout={ 1 } >

				<div className={ chat.speaker + "ChatItem" }>
					{ avatarCircle }
					{ chatBox }
					{ readChatControls }
				</div>
			</CSSTransition>
		);
	}
	renderChatChoices(chat) {
		var chatChoices = chat.text.split(";");

		var choicesDisplay = _.map(chatChoices, (choiceText, index) => {
			var chat = _.extend({}, this.state.currentChat, { text: choiceText, type: "static" });

			return (
				<div className="chatChoice clickableElement" key={ "choice-" + index }
					onClick={ this.props.advanceStageF.bind(this, chat, 1) }>
					{ choiceText }
				</div>
			);
		});

		return (
			<div className="chatChoicesDisplay">
				{ choicesDisplay }
			</div>
		);
	}

	render() {
		var chatHistoryDisplay = _.map(this.props.history, (chat, index) => {
			return this.renderChatItem(chat, index);
		});

		var currentChat = this.state.currentChat;
		if (this.state.isTyping) {
			var typingDisplay = (
				<CSSTransition classNames="slide" key={ "typing_display-"+chatHistoryDisplay.length }
				timeout={{ enter: 10, exit: .9 }}
				transitionEnterTimeout={ 10 } transitionLeaveTimeout={ .9 } >
					<div className="typingDisplay">
						<Glyphicon icon="option-horizontal" className="typingIcon" />
					</div>
				</CSSTransition>
			);
			chatHistoryDisplay.push(typingDisplay);
		} else if (currentChat.type == "static") {

			// Check if this is a weird in-between renders millisecond where we'd be doubling up
			var lastHistory = _.last(this.props.history);
			if ((lastHistory == undefined) || (lastHistory.stage != currentChat.stage)) {
				// Add the "currentChat" item to the end of the history
				chatHistoryDisplay.push(this.renderChatItem(currentChat, this.props.history.length));
			}
		} else {
			var currentChatChoices = this.renderChatChoices(currentChat);
		}

		return (
			<div className="owlfonsoChat">
				<div className="chatHistory clearfix">
					<TransitionGroup>
						{ chatHistoryDisplay }
					</TransitionGroup>
				</div>
				{ currentChatChoices }
			</div>
		);
	}

	resetTimeouts() {
		var currentChat = this.props.currentChat;
		if (currentChat.speaker == "owlfonso") {
			currentChat = this.parseCurrentChatText();

			this.setState({ isTyping: true, currentChat: currentChat }, () => {
				this.props.scrollToBottomF();
				setTimeout(() => {
					this.setState({ isTyping: false }, () => {
						this.props.scrollToBottomF();
						setTimeout(() => {
							this.props.advanceStageF(currentChat, currentChat.increment);
						}, 1200);
					});
				}, 1200);
			});
		} else {
			this.setState({ currentChat: currentChat }, () => {
				this.props.scrollToBottomF();
			});
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.currentChat.stage != this.props.currentChat.stage) {
			this.resetTimeouts();
		}
	}

	componentDidMount() {
		this.resetTimeouts();
	}
}

var STUDENT_NAME = "{{STUDENT_NAME}}";
var ASSIGNMENT_METRICS = "{{ASSIGNMENT_METRICS}}";
var ASSIGNMENT_TIME_PERIOD = "{{ASSIGNMENT_TIME_PERIOD}}";

var REPLACEMENT_STRINGS = [
	STUDENT_NAME, ASSIGNMENT_METRICS, ASSIGNMENT_TIME_PERIOD
];

OwlfonsoChat.propTypes = StrictPropTypes({
	// all previous chat messages
	history: PropTypes.array.isRequired,

	// current chat message
	currentChat: PropTypes.object.isRequired,

	// function to advance the stage to the next chat message
	advanceStageF: PropTypes.func.isRequired,

	// function to scroll down to the bottom of the chat area
	scrollToBottomF: PropTypes.func.isRequired,

	// to only display the user's initial, not their avatar
	initialOnly: PropTypes.bool,
});

module.exports = OwlfonsoChat;


// WEBPACK FOOTER //
// ./modules/components/users/students/onboarding/OwlfonsoChat.js